export type DemoIdentityKind = 'individual' | 'institution';

export type DemoIdentity = {
  name: string;
  avatar: string;
  kind: DemoIdentityKind;
  subtitle: string;
};

/** Canonical fictional identities shared by every public marketing demo. */
export const DEMO_IDENTITIES = {
  sophieLin: {
    name: 'Sophie Lin',
    avatar: '/demo-avatars/sophie-lin.png',
    kind: 'individual',
    subtitle: 'Newcomer journey builder',
  },
  amaraOkonkwo: {
    name: 'Amara Okonkwo',
    avatar: '/demo-avatars/amara-okonkwo.png',
    kind: 'individual',
    subtitle: 'Community health volunteer',
  },
  kenjiYamamoto: {
    name: 'Kenji Yamamoto',
    avatar: '/demo-avatars/kenji-yamamoto.png',
    kind: 'individual',
    subtitle: 'Family historian',
  },
  pacificHeritageMuseum: {
    name: 'Pacific Heritage Museum',
    avatar: '/demo-avatars/pacific-heritage-museum.svg',
    kind: 'institution',
    subtitle: 'Community memory archive',
  },
  vancouverHeritageLab: {
    name: 'Vancouver Heritage Lab',
    avatar: '/demo-avatars/vancouver-heritage-lab.svg',
    kind: 'institution',
    subtitle: 'Oral history programme',
  },
  coastalMemoryArchive: {
    name: 'Coastal Memory Archive',
    avatar: '/demo-avatars/coastal-memory-archive.svg',
    kind: 'institution',
    subtitle: 'Youth heritage wall',
  },
} as const satisfies Record<string, DemoIdentity>;
